import React, { useEffect, useState } from 'react';
import styles from './ncmViewContainer.module.scss';
import InformacaoBasica from '../../../../../../../../../../../components/informacaoBasica/informacaoBasica';
import { ICodigoNcm } from './../../../../../../../../../../../interfaces/IBaseDeCalculo';
import { formatCurrency } from './../../../../../../../../../../../utils/formatCurrency';
import { BrButton } from '@govbr-ds/react-components';
import { useBackEndRequests } from '../../../../../../../../../lib/backEndRequests';
import { Button, Modal } from 'react-dsgov';
import { useQuery } from '@tanstack/react-query';
import CustomConfirmer from '../../../../../../../../../../../components/customConfirmer/customConfirmer';
import { formatStringToBR } from '../../../../../../../../../../../utils/formatNumber';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

interface INCMViewContainerProps {
  codigoNCM: ICodigoNcm;
  hideAction?: boolean;
  setRefreshQuery: React.Dispatch<React.SetStateAction<boolean>>;
  setEdicaoNCM?: React.Dispatch<React.SetStateAction<ICodigoNcm | undefined>>;
}

const NCMViewContainer: React.FC<INCMViewContainerProps> = ({
  codigoNCM,
  hideAction,
  setRefreshQuery,
  setEdicaoNCM,
}) => {
  const { deleteVendaDiretaItemPLG, deleteRepasseParceiroItemPLG } = useBackEndRequests();
  const [openModal, setOpenModal] = useState(false);
  const [idVendaItemADeletar, setIdVendaItemADeletar] = useState<number>();
  const [idRepasseItemADeletar, setIdRepasseItemADeletar] = useState<number>();
  const [exclusaoConfirmada, setExclusaoConfirmada] = useState(false);

  const { data: deleteVendaDiretaItemData } = useQuery<string, IErrorWithSentryId>({
    queryKey: ['deleteVendaDiretaItemPLG', idVendaItemADeletar],
    queryFn: async () => {
      await deleteVendaDiretaItemPLG(idVendaItemADeletar!);
      return 'Item excluído com sucesso';
    },
    enabled: !!idVendaItemADeletar && exclusaoConfirmada,
  });

  const { data: deleteRepasseParceiroItemData } = useQuery<string, IErrorWithSentryId>({
    queryKey: ['deleteRepasseParceiroItemPLG', idRepasseItemADeletar],
    queryFn: async () => {
      await deleteRepasseParceiroItemPLG(idRepasseItemADeletar!);
      return 'Item excluído com sucesso';
    },
    enabled: !!idRepasseItemADeletar && exclusaoConfirmada,
  });

  const abrirFecharModal = () => {
    setOpenModal(!openModal);
  };

  useEffect(() => {
    if (deleteVendaDiretaItemData) {
      setExclusaoConfirmada(false);
      setIdVendaItemADeletar(undefined);
      setRefreshQuery(true);
    }
  }, [deleteVendaDiretaItemData]);

  useEffect(() => {
    if (deleteRepasseParceiroItemData) {
      setExclusaoConfirmada(false);
      setIdRepasseItemADeletar(undefined);
      setRefreshQuery(true);
    }
  }, [deleteRepasseParceiroItemData]);

  const confirmarExclusao = async () => {
    setExclusaoConfirmada(true);
    abrirFecharModal();
  };

  const removerNCM = (idItem: number, idVendaDireta: number) => {
    abrirFecharModal();
    if (idVendaDireta) setIdVendaItemADeletar(idItem);
    else setIdRepasseItemADeletar(idItem);
  };

  return (
    <div className={styles.containerNCM}>
      <InformacaoBasica
        aria-label={`Código NCM: ${codigoNCM.codigoNCM}`}
        titulo='Código NCM'
        conteudo={codigoNCM.codigoNCM}
      />
      <InformacaoBasica
        aria-label={`Quantidade: ${formatStringToBR(codigoNCM.quantidade.toString())}`}
        titulo='Quantidade'
        conteudo={formatStringToBR(codigoNCM.quantidade.toString())}
      />
      <InformacaoBasica
        aria-label={`Unidade de medida: ${codigoNCM.unidadeMedida}`}
        titulo='Uni. de Medida'
        conteudo={codigoNCM.unidadeMedida || ''}
      />
      <InformacaoBasica
        aria-label={`Valor: ${codigoNCM.valor}`}
        titulo='Valor'
        conteudo={formatCurrency(codigoNCM.valor)}
      />
      <InformacaoBasica
        aria-label={`Custo: ${codigoNCM.valor}`}
        titulo='Custo unitário'
        conteudo={formatCurrency(Number(codigoNCM.valor) / Number(codigoNCM.quantidade))}
      />
      <InformacaoBasica
        aria-label={`Rejeito: ${codigoNCM.isRejeito}`}
        titulo='Rejeitos/Estéreis'
        conteudo={codigoNCM.isRejeito ? 'Sim' : 'Não'}
      />
      {!hideAction && (
        <div className={styles.botoes}>
          <BrButton
            circle
            icon='fas fa-edit fa-md'
            secondary
            aria-label='Editar'
            title='Editar'
            onClick={() => setEdicaoNCM && setEdicaoNCM(codigoNCM)}
          />
          <BrButton
            secondary
            circle
            onClick={() => removerNCM(codigoNCM.id || 0, codigoNCM.idVendaDireta || 0)}
            aria-label='Excluir'
            title='Excluir'
          >
            <i className={`fas fa-trash-alt fa-md  ${styles.columnIcon}`} />
          </BrButton>
        </div>
      )}
      <Modal title='Excluir Operação PLG' useScrim modalOpened={openModal}>
        <Modal.Body>Deseja excluir o item selecionado?</Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={abrirFecharModal}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => confirmarExclusao()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NCMViewContainer;
